import React from 'react'
import { LPCaseStudySection } from '../../api/Types'
import LandingPageSectionWrapper from '../common/LandingPageSectionWrapper'
import I18n from '../../../../helpers/I18n'
import CaseStudyHero from '../../common/case_studies/CaseStudyHero'
import DynamicCallToAction from '../common/DynamicCallToAction'
import { TechDocsUrlPrefixes } from '../../models/Constants'

type Props = LPCaseStudySection

const LandingPageCaseStudy: React.FunctionComponent<Props> = ({ style, uuid, resourcesByUuid }) => {
  const resource = resourcesByUuid[uuid]

  if (!resource) {
    return null
  }

  return (
    <LandingPageSectionWrapper cssNamespace='case-study-section' style={style}>
      <CaseStudyHero caseStudy={resource} />
      <DynamicCallToAction
        cta={{
          label: I18n.t('views.cms.landing_pages.case_study.cta_label'),
          url: `/${TechDocsUrlPrefixes.CaseStudy}/${resource.url_slug}`,
          color: 'secondary',
        }}
      />
    </LandingPageSectionWrapper>
  )
}

export default LandingPageCaseStudy
